import {
  Button,
  FormControl,
  Heading,
  Input,
  Stack,
  useColorModeValue,
  Link,
  Stat,
  StatHelpText,
  StatLabel,
  StatNumber,
  Image,
  VStack,
  HStack,
  FormLabel,
} from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import {
  useAccount,
  useContractRead,
  useContractWrite,
  usePrepareContractWrite,
  useWaitForTransaction,
} from 'wagmi'
import { useDebounce } from '../hooks'
import SubtleFacesABI from '../assets/constants/abi/SubtleFaces.json'
import MintSvg from '../assets/mint.svg'
import { GistDisplay } from '../components'
import NetworkMapping from '../assets/constants/network-mapping.json'

export default function SubtleFaces() {
  const [text, setText] = useState('')
  const debouncedText = useDebounce(text, 500)
  const { isDisconnected } = useAccount()

  const { data: maxSupply } = useContractRead({
    address: NetworkMapping['80001']['SubtleFaces'] as `0x${string}`,
    abi: SubtleFacesABI,
    functionName: 'MAX_SUPPLY',
  })

  const { data: currentSupply } = useContractRead({
    address: NetworkMapping['80001']['SubtleFaces'] as `0x${string}`,
    abi: SubtleFacesABI,
    functionName: 'totalSupply',
  })

  const {
    config,
    error: prepareError,
    isError: isPrepareError,
  } = usePrepareContractWrite({
    address: NetworkMapping['80001']['SubtleFaces'] as `0x${string}`,
    abi: SubtleFacesABI,
    functionName: 'setData',
    args: [debouncedText],
    enabled: Boolean(debouncedText),
  })

  const { data, error, isError, write } = useContractWrite(config)

  const { isLoading, isSuccess } = useWaitForTransaction({
    hash: data?.hash,
  })

  useEffect(() => {
    setText('')
  }, [isSuccess])

  return (
    <VStack
      spacing={{ base: '30px' }}
      minH={{ base: '80vh', md: '80vh' }}
      wrap={'wrap'}
      align={'center'}
      justify={'center'}
      mb={'10px'}
    >
      <HStack
        minH={{ base: '80vh', md: '80vh' }}
        wrap={'wrap'}
        align={'center'}
        justify={'center'}
        mb={'10px'}
      >
        <Image src={MintSvg} boxSize={{ base: 'xs', md: 'md' }}></Image>
        <Stack
          spacing={4}
          bg={useColorModeValue('white', 'gray.700')}
          rounded={'xl'}
          boxShadow={'lg'}
          p={{ base: '12', md: '20' }}
          my={{ base: '6', md: '12' }}
        >
          <Heading
            lineHeight={1.5}
            fontSize={{ base: '2xl', md: '4xl' }}
            color={'brand.500'}
            alignSelf={'center'}
          >
            Subtle Faces
          </Heading>
          <Heading
            lineHeight={1.2}
            fontSize={{ base: '2xl', md: '3xl' }}
            color={'second.500'}
            alignSelf={'center'}
          >
            {`Hello`}
          </Heading>
          <FormControl id="email">
            <FormLabel>{`${currentSupply}/${maxSupply}`}</FormLabel>
          </FormControl>
          <Stack spacing={6}>
            <Button
              bg={'brand.500'}
              color={'white'}
              _disabled={{
                bg: 'gray.600',
                cursor: 'not-allowed',
              }}
              _hover={{
                bg: 'brand.600',
              }}
              onClick={(e) => {
                e.preventDefault()
                write?.()
              }}
              isDisabled={!write || isLoading || !text}
            >
              {isDisconnected
                ? 'Wallet Not Connected'
                : isLoading
                ? 'Minting...'
                : 'Mint Your Face'}
            </Button>
            {isSuccess && (
              <Stat>
                <StatLabel>Subtle Face Mint Successfully</StatLabel>
                <StatNumber>
                  {data && (
                    <Link href={`https://mumbai.polygonscan.com/tx/${data?.hash}`} target="_blank">
                      View Transaction
                    </Link>
                  )}
                </StatNumber>
                <StatHelpText></StatHelpText>
              </Stat>
            )}
            {(isPrepareError || isError) && <div>Error: {(prepareError || error)?.message}</div>}
          </Stack>
        </Stack>
      </HStack>

      {/* <Center bg={useColorModeValue('gray.50', 'gray.800')} mt={'-1rem'}>
          <ChevronDownIcon boxSize={12} />
        </Center> */}
      <GistDisplay id={'f09f0bff7f354ed8763db296a6912976'} />
    </VStack>
  )
}
